export default "/images/7b7f7046a54bed8c1dd30896f37f3d22.avif";